var ResourceUtils = {
  getFieldList: function(_type){
    var _fieldList = [];
    switch (_type) {
      //server
      case 'Equipment.Unix':
        _fieldList = [
          {key: 'ServerAddress', required: true, zh: "资源IP"},
          {key: 'OS', required: true, zh: "操作系统"},
          {key: 'Connectiontype', required: true, zh: "连接方式"},
          {key: 'KeepaLives', required: true, zh: "连接数"},
          {key: 'Authentication', required: true, zh: "连接权限"},
          {key: 'KeyFile', zh: "秘钥文件"},
          {key: 'Port', required: true, zh: "端口"},
          {key: 'UserName', required: true, zh: "用户名"},
          {key: 'Passwd', required: true, zh: "密码"}
        ];
        break;
      case 'Equipment.SNMPWindows':
        _fieldList = [
          {key: 'EquipmentModel', zh: "资源型号"},
          {key: 'ServerAddress', required: true, zh: "资源IP"},
          {key: 'Port', required: true, zh: "端口"},
          {key: 'Community', required: true, zh: "共同体"},
          {key: 'KeepaLives', required: true, zh: "连接数"},
          {key: 'Edition', zh: "版本"}
        ];
        break;
      case 'Equipment.Windows':
        _fieldList = [
          {key: 'ServerAddress', required: true, zh: "资源IP"},
          {key: 'OS', required: true, zh: "操作系统"},
          {key: 'Connectiontype', required: true, zh: "连接方式"},
          {key: 'KeepaLives', required: true, zh: "连接数"},
          {key: 'UserName', required: true, zh: "用户名"},
          {key: 'Passwd', required: true, zh: "密码"}
        ];
        break;
      case 'Equipment.SNMPUnix':
        _fieldList = [
          {key: 'EquipmentModel', zh: "资源型号"},
          {key: 'ServerAddress', required: true, zh: "资源IP"},
          {key: 'Port', required: true, zh: "端口"},
          {key: 'Community', required: true, zh: "共同体"},
          {key: 'OS', required: true, zh: "操作系统"},
          {key: 'KeepaLives', required: true, zh: "连接数"},
          {key: 'Edition', zh: "版本"},
          {key: 'AuthenticationProtocol', zh: "验证算法"},
          {key: 'UserName', zh: "用户名"},
          {key: 'Passwd', zh: "密码"},
          {key: 'PrivacyProtocol', zh: "隐私算法"},
          {key: 'PrivacyPwd', zh: "隐私密码"}
        ];
        break;
      case 'Equipment.IPMIServer':
        _fieldList = [
          {key: 'ServerAddress', required: true, zh: "资源IP"},
          {key: 'UserName', required: true, zh: "用户名"},
          {key: 'Passwd', required: true, zh: "密码"}
        ];
        break;
      case 'Equipment.TaskSchedule':
      case 'Equipment.ASGSentry':
      case 'Equipment.Server':
        _fieldList = [
          {key: 'ServerAddress', required: true, zh: "资源IP"},
          {key: 'OS', required: true, zh: "操作系统"}
        ];
        break;
      //DataBase
      case 'Equipment.Mysql':
      case 'Equipment.SqlServer':
      case 'Equipment.MongoDB':
        _fieldList = [
          {key: 'ServerAddress', required: true, zh: "数据库IP"},
          {key: 'DATABASE_NAME', required: true, zh: "数据库名"},
          {key: 'KeepaLives', required: true, zh: "连接数"},
          {key: 'Port', required: true, zh: "端口"},
          {key: 'UserName', required: true, zh: "用户名"},
          {key: 'Passwd', required: true, zh: "密码"}
        ];
        break;
      case 'Equipment.Postgresql':
        _fieldList = [
          {key: 'ServerAddress', required: true, zh: "数据库IP"},
          {key: 'DATABASE_NAME', required: true, zh: "数据库名"},
          {key: 'Schemas', required: false, zh: "Schemas"},
          {key: 'KeepaLives', required: true, zh: "连接数"},
          {key: 'Port', required: true, zh: "端口"},
          {key: 'UserName', required: true, zh: "用户名"},
          {key: 'Passwd', required: true, zh: "密码"}
        ];
        break;
      case 'Equipment.DB2':
        _fieldList = [
          {key: 'URL', required: true, zh: "URL"},
          {key: 'Drivers', required: true, zh: "数据库驱动"},
          {key: 'KeepaLives', required: true, zh: "连接数"},
          {key: 'UserName', required: true, zh: "用户名"},
          {key: 'Passwd', required: true, zh: "密码"}
        ];
        break;
      case 'Equipment.Hadoop':
        _fieldList = [
          {key: 'URL', required: true, zh: "JMX Url"},
          {key: 'ComputerName', required: true, zh: "域筛选器"},
          {key: 'UserName', required: true, zh: "用户名"},
          {key: 'Passwd', required: true, zh: "密码"}
        ];
        break;
      case 'Equipment.SyBase':
      case 'Equipment.Informix':
        _fieldList = [
          {key: 'ServerAddress', required: true, zh: "ODBC数据源"},
          {key: 'KeepaLives', required: true, zh: "连接数"},
          {key: 'UserName', required: true, zh: "用户名"},
          {key: 'Passwd', required: true, zh: "密码"}
        ];
        break;
      case 'Equipment.DataBase':
        _fieldList = [
          {key: 'ServerAddress', required: true, zh: "ODBC数据源"},
          {key: 'KeepaLives', required: true, zh: "连接数"},
          {key: 'UserName', required: false, zh: "用户名"},
          {key: 'Passwd', required: false, zh: "密码"}
        ];
        break;
      case 'Equipment.Oracle':
        _fieldList = [
          {key: 'ServerAddress', required: true, zh: "数据库IP"},
          {key: 'ConnectionType', required: true, zh: "连接方式"},
          {key: 'DATABASE_NAME', required: true, zh: "数据库名"},
          {key: 'KeepaLives', required: true, zh: "连接数"},
          {key: 'Port', required: true, zh: "端口"},
          {key: 'UserName', required: true, zh: "用户名"},
          {key: 'Passwd', required: true, zh: "密码"}
        ];
        break;
      //MiddleWare
      case 'Equipment.MiddleWare':
        _fieldList = [];
        break;
      case 'Equipment.Weblogic':
        _fieldList = [
          {key: 'ServerAddress', required: true, zh: "主机名"},
          {key: 'Port', required: true, zh: "端口"},
          {key: 'UserName', required: true, zh: "用户名"},
          {key: 'Passwd', required: true, zh: "密码"}
        ];
        break;
      case 'Equipment.Websphere':
        _fieldList = [
          {key: 'URL', required: true, zh: "URL"},
          {key: 'Safe', zh: "启用安全策略"},
          {key: 'UserName', required: false, zh: "用户名"},
          {key: 'Passwd', required: false, zh: "密码"}
        ];
        break;
      case 'Equipment.WebSpherePreServlet':
        _fieldList = [
          {key: 'ServerAddress', required: true, zh: "服务器"},
          {key: 'Port', required: true, zh: "端口"},
          {key: 'URL', required: true, zh: "管理URL"},
          {key: 'AuthenticationUser', zh: "授权用户"},
          {key: 'AuthenticationPasswd', zh: "授权密码"},
          {key: 'AgencyService', zh: "代理服务器"},
          {key: 'AgencyUser', zh: "代理用户"},
          {key: 'AgencyPasswd', zh: "代理密码"}
        ];
        break;
      //ApplicationSystem
      case 'Equipment.Apache':
        _fieldList = [{key: 'ServerAddress', required: true, zh: "资源IP"}];
        break;
      case 'Equipment.Tomcat':
        _fieldList = [{key: 'ServerAddress', required: true, zh: "资源IP"}];
        break;
      case 'Equipment.Nginx':
        _fieldList = [{key: 'ServerAddress', required: true, zh: "资源IP"}];
        break;
      case 'Equipment.IIS':
        _fieldList = [
          {key: 'ServerAddress', required: true, zh: "资源IP"},
          {key: 'OS', required: true, zh: "操作系统"},
          {key: 'Connectiontype', required: true, zh: "连接方式"},
          {key: 'KeepaLives', required: true, zh: "连接数"},
          {key: 'UserName', required: true, zh: "用户名"},
          {key: 'Passwd', required: true, zh: "密码"}
        ];
        break;
      case 'Equipment.Router':
        _fieldList = [{key: 'Mac', required: true, zh: "Mac"}];
        break;
      case 'Equipment.Oracle9iAppServer':
        _fieldList = [
          {key: 'URL', required: true, zh: "管理URL"},
          {key: 'UserName', required: false, zh: "授权用户"},
          {key: 'Passwd', required: false, zh: "授权密码"},
          {key: 'ComputerName', required: false, zh: "HTTP代理"},
          {key: 'Authentication', required: false, zh: "代理用户"},
          {key: 'PasswordPrompt', required: false, zh: "代理密码"}
        ];
        break;
      case 'Equipment.Oracle10gAppServer':
        _fieldList = [
          {key: 'ServerAddress', required: true},
          {key: 'Port', required: true},
          // {key: 'AuthenticationUser', zh: "授权用户"},
          // {key: 'AuthenticationPasswd', zh: "授权密码"},
          // {key: 'AgencyService', zh: "代理服务器"},
          // {key: 'AgencyUser', zh: "代理用户"},
          // {key: 'AgencyPasswd', zh: "代理密码"}
          {key: 'UserName', required: false, zh: "授权用户"},
          {key: 'Passwd', required: false, zh: "授权密码"},
          {key: 'ComputerName', required: false, zh: "代理服务器"},
          {key: 'Authentication', required: false, zh: "代理用户"},
          {key: 'PasswordPrompt', required: false, zh: "代理密码"},
          {key: 'AuthenticationProtocol', required: false, zh: "度量类型"},
          {key: 'Protocol', required: false, zh: "安全服务器"}
        ];
        break;
      case 'Equipment.WebSphereMQ':
        _fieldList = [
          {key: 'ServerAddress', required: true, zh: "MQ服务器名称"},
          {key: 'Port', required: true, zh: "端口"},
          {key: 'DATABASE_NAME', required: true, zh: "服务器连接通道"},
          {key: 'KeyFile', required: true, zh: "队列管理器"},
          {key: 'UserName', required: false, zh: "用户名"},
          {key: 'Passwd', required: false, zh: "密码"},
          {key: 'ComputerName', required: false, zh: "备用列队管理器"},
          {key: 'Community', required: false, zh: "通道状态代码方案"},
          {key: 'PasswordPrompt', required: false, zh: "密码套件"}
        ];
        break;
      case 'Equipment.WebSphereAppServer':
        _fieldList = [
          {key: 'ServerAddress', required: true, zh: "服务器"},
          {key: 'Port', required: true, zh: "端口"},
          {key: 'Edition', required: true, zh: "版本"},
          {key: 'KeyFile', required: false, zh: "WebSphere目录"},
          {key: 'URL', required: false, zh: "类路径"},
          {key: 'Drivers', required: false, zh: "信任存储"},
          {key: 'PasswordPrompt', required: false, zh: "信任存储密码"},
          {key: 'AgentServer', required: false, zh: "密钥存储"},
          {key: 'PrivacyPwd', required: false, zh: "密钥存储密码"},
          {key: 'Authentication', required: false, zh: "客户端属性文件"},
          {key: 'ComputerName', required: false, zh: "安全领域"},
          {key: 'UserName', required: false, zh: "用户名"},
          {key: 'Passwd', required: false, zh: "密码"},
          {key: 'Protocol', required: false, zh: "启动外部JVM"}
        ];
        break;
      //MailSystem
      case 'Equipment.Exchange':
      case 'Equipment.LotusNotes':
      case 'Equipment.Mail':
      case 'Equipment.MailSystem':
        break;
      //WebSite
      case 'Equipment.DNS':
      case 'Equipment.DomainManagement':
      case 'Equipment.URL':
      case 'Equipment.URLContent':
      case 'Equipment.URLList':
      case 'Equipment.URLSequence':
      case 'Equipment.WebSite':
        break;
      case 'Equipment.FTP':
        _fieldList = [
          {key: 'ServerAddress', required: true, zh: "资源IP"},
          {key: 'Port', required: true, zh: "端口"},
          {key: 'UserName', required: true, zh: "用户名"},
          {key: 'Passwd', required: true, zh: "密码"}
        ];
        break;
      //NetWork
      case 'Equipment.VPPNDiscovery':
        break;
      case 'Equipment.VppnRouter':
        _fieldList = [
          {key: 'EquipmentModel', zh: "资源型号"},
          {key: 'ServerAddress', required: true, zh: "密钥存储密码"},
          {key: 'URL', required: true, zh: "通讯地址"},
          {key: 'Mac', required: true, zh: "Mac地址"},
          {key: 'Edition', zh: "版本"},
          {key: 'KeyFile', zh: "公钥信息"},
        ];
        break;
      case 'Equipment.Network':
        _fieldList = [
          {key: 'EquipmentModel', zh: "资源型号"},
          {key: 'ServerAddress', required: true, zh: "密钥存储密码"},
          {key: 'Port', required: true, zh: "端口"},
          {key: 'Community', required: true, zh: "共同体"},
          {key: 'KeepaLives', required: true, zh: "连接数"},
          {key: 'Edition', zh: "版本"},
          {key: 'AuthenticationProtocol', zh: "验证算法"},
          {key: 'UserName', zh: "用户名"},
          {key: 'Passwd', zh: "密码"},
          {key: 'PrivacyProtocol', zh: "隐私算法"},
          {key: 'PrivacyPwd', zh: "隐私密码"}
        ];
        break;
      //FireWall
      case 'Equipment.CheckPoint':
      case 'Equipment.Netscreen':
      case 'Equipment.PIX':
        _fieldList = [
          {key: 'ServerAddress', required: true, zh: "资源IP"},
          {key: 'Port', required: true, zh: "端口"},
          {key: 'Community', required: true, zh: "共同体"},
          {key: 'KeepaLives', required: true, zh: "连接数"},
          {key: 'Edition', zh: "版本"},
          {key: 'AuthenticationProtocol', zh: "验证算法"},
          {key: 'UserName', zh: "用户名"},
          {key: 'Passwd', zh: "密码"},
          {key: 'PrivacyProtocol', zh: "隐私算法"},
          {key: 'PrivacyPwd', zh: "隐私密码"}
        ];
        break;
      case 'Equipment.FireWall':
        _fieldList = [
          {key: 'EquipmentModel', zh: "资源型号"},
          {key: 'ServerAddress', required: true, zh: "资源IP"},
          {key: 'Port', required: true, zh: "端口"},
          {key: 'Community', required: true, zh: "共同体"},
          {key: 'KeepaLives', required: true, zh: "连接数"},
          {key: 'Edition', zh: "版本"},
          {key: 'AuthenticationProtocol', zh: "验证算法"},
          {key: 'UserName', zh: "用户名"},
          {key: 'Passwd', zh: "密码"},
          {key: 'PrivacyProtocol', zh: "隐私算法"},
          {key: 'PrivacyPwd', zh: "隐私密码"}
        ];
        break;
      //LoadBalancing
      case 'Equipment.LoadBalancing':
        _fieldList = [];
        break;
      case 'Equipment.F5BigIp':
        _fieldList = [
          {key: 'ServerAddress', required: true, zh: "资源IP"},
          {key: 'Port', required: true, zh: "端口"},
          {key: 'Community', required: true, zh: "共同体"},
          {key: 'KeepaLives', required: true, zh: "连接数"},
          {key: 'Edition', zh: "版本"},
          {key: 'AuthenticationProtocol', zh: "验证算法"},
          {key: 'UserName', zh: "用户名"},
          {key: 'Passwd', zh: "密码"},
          {key: 'PrivacyProtocol', zh: "隐私算法"},
          {key: 'PrivacyPwd', zh: "隐私密码"}
        ];
        break;
      //WirelessNetwork
      case 'Equipment.ABLOOMY':
        _fieldList = [
          {key: 'ServerAddress', required: true, zh: "资源IP"},
          {key: 'OS', required: true, zh: "操作系统"}
        ];
        break;
      case 'Equipment.WirelessNetwork':
        _fieldList = [
          {key: 'EquipmentModel', zh: "资源型号"},
          {key: 'ServerAddress', required: true, zh: "资源IP"},
          {key: 'Port', required: true, zh: "端口"},
          {key: 'Community', required: true, zh: "共同体"},
          {key: 'KeepaLives', required: true, zh: "连接数"},
          {key: 'Edition', zh: "版本"},
          {key: 'AuthenticationProtocol', zh: "验证算法"},
          {key: 'UserName', zh: "用户名"},
          {key: 'Passwd', zh: "密码"},
          {key: 'PrivacyProtocol', zh: "隐私算法"},
          {key: 'PrivacyPwd', zh: "隐私密码"}
        ];
        break;
      //ComputerRoomEnvironment
      case 'Equipment.APC':
      case 'Equipment.APEM6100':
      case 'Equipment.Emerson':
      case 'Equipment.IOTDevice':
      case 'Equipment.LiebertCorp':
      case 'Equipment.Raritan':
      case 'Equipment.Santakups':
      case 'Equipment.DME3000':
        _fieldList = [
          {key: 'ServerAddress', required: true, zh: "资源IP"},
          {key: 'Port', required: true, zh: "端口"},
          {key: 'Community', required: true, zh: "共同体"},
          {key: 'KeepaLives', required: true, zh: "连接数"},
          {key: 'Edition', zh: "版本"},
          {key: 'AuthenticationProtocol', zh: "验证算法"},
          {key: 'UserName', zh: "用户名"},
          {key: 'Passwd', zh: "密码"},
          {key: 'PrivacyProtocol', zh: "隐私算法"},
          {key: 'PrivacyPwd', zh: "隐私密码"}
        ];
        break;
      //VirtualMachine
      case 'Equipment.VMware':
        _fieldList = [
          {key: 'ServerAddress', required: true, zh: "服务器IP"},
          {key: 'Port', required: true, zh: "端口", defaultValue: '443'},
          {key: 'UserName', required: true, zh: "用户名"},
          {key: 'Passwd', required: true, zh: "密码"}
        ];
        break;
      case 'Equipment.Hyper_V':
        _fieldList = [
          {key: 'ServerAddress', required: true, zh: "资源IP"},
          {key: 'OS', required: true, zh: "操作系统"},
          {key: 'Connectiontype', required: true, zh: "连接方式"},
          {key: 'KeepaLives', required: true, zh: "连接数"},
          {key: 'UserName', required: true, zh: "用户名"},
          {key: 'Passwd', required: true, zh: "密码"}
        ];
        break;
      //Storage
      case 'Equipment.Storage':
      case 'Equipment.HPStorage':
        _fieldList = [];
        break;
      case 'Equipment.EMCStorage':
        _fieldList = [
          {key: 'ServerAddress', required: true, zh: "存储IP"},
          {key: 'UserName', required: true, zh: "用户名"},
          {key: 'Passwd', required: true, zh: "密码"}
        ];
        break;
      case 'Equipment.IBMStorage':
        _fieldList = [
          {key: 'ServerAddress', required: true, zh: "存储IP"},
          {key: 'Protocol', required: true, zh: "协议"},
          {key: 'Port', required: true, zh: "端口"},
          {key: 'UserName', required: true, zh: "用户名"},
          {key: 'Passwd', required: true, zh: "密码"}
        ];
        break;
      case 'Equipment.UniversalStorage':
        _fieldList = [
          {key: 'EquipmentModel', zh: "资源型号"},
          {key: 'ServerAddress', required: true, zh: "资源IP"},
          {key: 'Port', required: true, zh: "端口"},
          {key: 'Community', required: true, zh: "共同体"},
          {key: 'KeepaLives', required: true, zh: "连接数"},
          {key: 'Edition', zh: "版本"},
          {key: 'AuthenticationProtocol', zh: "验证算法"},
          {key: 'UserName', zh: "用户名"},
          {key: 'Passwd', zh: "密码"},
          {key: 'PrivacyProtocol', zh: "隐私算法"},
          {key: 'PrivacyPwd', zh: "隐私密码"}
        ];
        break;
      default:
        break;
    }
    return _fieldList;
  },
  resourceData: [
    {resource: 'Network', resource_zh: '网络设备', types: ["Equipment.Network", "Equipment.VPPNDiscovery", "Equipment.VppnRouter"]},
    {resource: 'Server', resource_zh: '服务器', types: ["Equipment.Unix", "Equipment.SNMPUnix", "Equipment.Windows", "Equipment.SNMPWindows", "Equipment.IPMIServer", "Equipment.TaskSchedule", "Equipment.ASGSentry", "Equipment.Server"]},
    {resource: 'DataBase', resource_zh: '数据库', types: ["Equipment.Mysql", "Equipment.SqlServer", "Equipment.MongoDB", "Equipment.DB2", "Equipment.Hadoop", "Equipment.SyBase", "Equipment.Informix", "Equipment.Database", "Equipment.Oracle", "Equipment.Postgresql"]},
    {resource: 'MiddleWare', resource_zh: '中间件', types: ["Equipment.MiddleWare", "Equipment.Weblogic", "Equipment.Websphere", "Equipment.WebSpherePreServlet"]},
    {resource: 'ApplicationSystem', resource_zh: '应用系统', types: ["Equipment.Apache", "Equipment.Tomcat", "Equipment.Nginx", "Equipment.IIS", "Equipment.ConvenientApplication", "Equipment.Oracle9iAppServer", "Equipment.Oracle10gAppServer", "Equipment.WebSphereMQ", "Equipment.WebSphereAppServer"]},
    {resource: 'Storage', resource_zh: '存储', types: ["Equipment.Storage", "Equipment.HPStorage", "Equipment.EMCStorage", "Equipment.IBMStorage", "Equipment.UniversalStorage"]},
    {resource: 'WebSite', resource_zh: '网站', types: ["Equipment.DNS", "Equipment.DomainManagement", "Equipment.FTP", "Equipment.URL", "Equipment.URLContent", "Equipment.URLList", "Equipment.URLSequence", "Equipment.WebSite"]},
    {resource: 'WirelessNetwork', resource_zh: '无线网络', types: ["Equipment.WirelessNetwork", "Equipment.ABLOOMY"]},
    {resource: 'FireWall', resource_zh: '防火墙', types: ["Equipment.FireWall", "Equipment.CheckPoint", "Equipment.Netscreen", "Equipment.PIX"]},
    {resource: 'ComputerRoomEnvironment', resource_zh: '机房环境', types: ["Equipment.APC", "Equipment.APEM6100", "Equipment.Emerson", "Equipment.IOTDevice", "Equipment.LiebertCorp", "Equipment.Raritan", "Equipment.Santakups", "Equipment.DME3000"]},
    {resource: 'VirtualMachine', resource_zh: '虚拟机', types: ["Equipment.VMware", "Equipment.Hyper_V"]},
    {resource: 'LoadBalancing', resource_zh: '负载均衡', types: ["Equipment.LoadBalancing", "Equipment.F5BigIp"]},
    {resource: 'MailSystem', resource_zh: '邮件系统', types: ["Equipment.Exchange", "Equipment.LotusNotes", "Equipment.Mail", "Equipment.MailSystem"]},
    {resource: 'BatteryPack', resource_zh: '电池组', types: ["Equipment.BatteryPack"]},
  ],
  resourceOption: {
    SNMPWindows: [
      {type: 'Ping', checked: true, isDisk: false, header: 'Ping监测器', content: 'ping', title: 'Ping'},
      {type: 'CPU', checked: true, isDisk: false, header: 'CPU监测器', content: 'cpu', title: 'CPU'},
      {type: 'Memory', checked: true, isDisk: false, header: '内存监测器', content: 'memory', title: '内存'},
      {type: 'DiskSpace', checked: false, isDisk: true, header: '磁盘监测器', title: '磁盘'},
      {type: 'NetWork', checked: false, isDisk: true, header: '网络接口监测器', title: '网卡', suffix: 'status'},
      {type: 'SnmpProcess', checked: false, isDisk: true, header: '进程监测器', title: '进程'}
    ],
    IPMIServer: [{type: 'Ping', checked: true, isDisk: false, header: 'Ping监测器', content: 'ping', title: 'Ping'}],
    Windows: [
      {type: 'Ping', checked: true, isDisk: false, header: 'Ping监测器', content: 'ping', title: 'Ping'},
      {type: 'CPU', checked: true, isDisk: false, header: 'CPU监测器', content: 'cpu', title: 'CPU'},
      {type: 'Memory', checked: true, isDisk: false, header: '内存监测器', content: 'memory', title: '内存'},
      {type: 'DiskSpace', checked: false, isDisk: true, header: '磁盘监测器', title: '磁盘'},
      {type: 'NetWork', checked: false, isDisk: true, header: '接口监测器', title: '网卡'},
      {type: 'Process', checked: false, isDisk: true, header: '进程监测器', title: '进程'}
    ],
    Unix: [
      {type: 'Ping', checked: true, isDisk: false, header: 'Ping监测器', content: 'ping', title: 'Ping'},
      {type: 'CPU', checked: true, isDisk: false, header: 'CPU监测器', content: 'cpu', title: 'CPU'},
      {type: 'Memory', checked: true, isDisk: false, header: '内存监测器', content: 'memory', title: '内存'},
      {type: 'DiskSpace', checked: false, isDisk: true, header: '磁盘监测器', title: '磁盘'},
      {type: 'NetWork', checked: false, isDisk: true, header: '接口监测器', title: '网卡'},
      {type: 'Process', checked: false, isDisk: true, header: '进程监测器', title: '进程'}
    ],
    SNMPUnix: [
      {type: 'Ping', checked: true, isDisk: false, header: 'Ping监测器', content: 'ping', title: 'Ping'},
      {type: 'CPU', checked: true, isDisk: false, header: 'CPU监测器', content: 'cpu', title: 'CPU'},
      {type: 'Memory', checked: true, isDisk: false, header: '内存监测器', content: 'memory', title: '内存'},
      {type: 'DiskSpace', checked: false, isDisk: true, header: '磁盘监测器', title: '磁盘'},
      {type: 'NetWork', checked: false, isDisk: true, header: '网络接口监测器', title: '网卡', suffix: 'status'},
      {type: 'SnmpProcess', checked: false, isDisk: true, header: '进程监测器', title: '进程'}
    ],
    Mysql: [
      {type: 'Ping', checked: false, isDisk: false, header: 'Ping监测器', content: 'ping', title: 'Ping'},
      {type: 'MysqlBase', checked: false, isDisk: false, header: '基本信息监测器', content: 'MySql基本信息', title: 'MysqlBase'},
      {type: 'MysqlProcess', checked: false, isDisk: false, header: '进程监测器', content: 'MySql进程', title: 'MySql进程'},
      {type: 'MysqlMemoryStatus', checked: false, isDisk: false, header: '内存状态', content: 'MySql内存状态', title: 'MySql内存状态'},
    ],
    SqlServer: [
      {type: 'Ping', checked: false, isDisk: false, header: 'Ping监测器', content: 'ping', title: 'Ping'},
      {type: 'SQLServerTransactions', checked: false, isDisk: false, header: 'SQLServer事务及日志', content: 'SQLServer事务及日志', title: 'SQLServer事务及日志'},
      {type: 'SQLBuffer', checked: false, isDisk: false, header: '监测SQL Server的BUFFER使用状况', content: 'SqlServer Buffer', title: 'SQLBuffer'},
      {type: 'SQLStatic', checked: false, isDisk: false, header: 'SqlServer请求统计', content: 'SQLStatic', title: 'SQLStatic'},
      {type: 'SQLServerLock', checked: false, isDisk: false, header: 'SQLServer死锁', content: 'SQLServerLock', title: 'SQLServer死锁'},
      {type: 'SQLUser', checked: false, isDisk: false, header: '监测SQL Server的用户使用状况', content: 'SQLUser', title: 'SQLUser'},
      {type: 'SQLMemory', checked: false, isDisk: false, header: '监测SQL Server的内存使用状况', content: 'SqlServer内存', title: 'SQLMemory'}
    ],
    Oracle: [
      {type: 'Ping', checked: false, isDisk: false, header: 'Ping监测器', content: 'ping', title: 'Ping'},
      {type: 'OracleInfo', checked: false, isDisk: false, header: '监测Oracle数据库信息', content: 'Oracle数据库信息', title: 'Oracle数据库信息'},
      {type: 'OracleConnections', checked: false, isDisk: false, header: 'Oracle数据库连接数', content: 'Oracle连接数', title: 'Oracle连接数'},
      {type: 'OracleSGA', checked: false, isDisk: false, header: '监测Oracle数据库SGA信息', content: 'Oracle SGA信息', title: 'Oracle SGA信息'},
      {type: 'OraclePerformance', checked: false, isDisk: false, header: '监测Oracle数据库性能', content: 'Oracle性能', title: 'Oracle性能'},
    ],
    Postgresql: [
      {type: 'Ping', checked: false, isDisk: false, header: 'Ping监测器', content: 'ping', title: 'Ping'},
      {type: 'Port', checked: false, isDisk: false, header: '端口监测器', content: '5432', title: 'PostgreSQL端口'},
      {type: 'PostgresqlBase', checked: false, isDisk: false, header: 'PostgreSQL基本信息', content: 'PostgreSQL基本信息', title: 'PostgreSQL基本信息'},
      {type: 'PostgresqlConnections', checked: false, isDisk: false, header: 'PostgreSQL连接数', content: 'PostgreSQL连接数', title: 'PostgreSQL连接数'},
      {type: 'PostgresqlLocks', checked: false, isDisk: false, header: 'PostgreSQL锁监测', content: 'PostgreSQL锁监测', title: 'PostgreSQL锁监测'},
      {type: 'PostgresqlTransactions', checked: false, isDisk: false, header: 'PostgreSQL事务统计', content: 'PostgreSQL事务统计', title: 'PostgreSQL事务统计'},
      {type: 'PostgresqlTableStats', checked: false, isDisk: false, header: 'PostgreSQL表统计', content: 'PostgreSQL表统计', title: 'PostgreSQL表统计'},
      {type: 'PostgresqlIndexStats', checked: false, isDisk: false, header: 'PostgreSQL索引统计', content: 'PostgreSQL索引统计', title: 'PostgreSQL索引统计'},
      {type: 'PostgresqlReplication', checked: false, isDisk: false, header: 'PostgreSQL复制状态', content: 'PostgreSQL复制状态', title: 'PostgreSQL复制状态'},
      {type: 'PostgresqlBuffer', checked: false, isDisk: false, header: 'PostgreSQL缓存命中率', content: 'PostgreSQL缓存命中率', title: 'PostgreSQL缓存命中率'},
      {type: 'PostgresqlDatabaseSize', checked: false, isDisk: false, header: 'PostgreSQL数据库大小', content: 'PostgreSQL数据库大小', title: 'PostgreSQL数据库大小'},
      {type: 'DataQuery', checked: false, isDisk: false, header: 'JDBC查询监测器', content: 'PostgreSQL JDBC查询', title: 'PostgreSQL JDBC查询'},
    ],
    MongoDB: [{type: 'Ping', checked: false, isDisk: false, header: 'Ping监测器', content: 'ping', title: 'Ping'}],
    Tomcat: [{type: 'Ping', checked: false, isDisk: false, header: 'Ping监测器', content: 'ping', title: 'Ping'}],
    Apache: [{type: 'Ping', checked: false, isDisk: false, header: 'Ping监测器', content: 'ping', title: 'Ping'}],
    Nginx: [{type: 'Ping', checked: false, isDisk: false, header: 'Ping监测器', content: 'ping', title: 'Ping'}],
    IIS: [{type: 'Ping', checked: false, isDisk: false, header: 'Ping监测器', content: 'ping', title: 'Ping'}],
    CheckPoint: [
      {type: 'Ping', checked: true, isDisk: false, header: 'Ping监测器', content: 'ping', title: 'Ping'},
      {type: 'SnmpUpTime', checked: true, isDisk: false, header: '设备运行时间监测器', content: '设备运行时间', title: '设备运行时间'},
      {type: 'NetWork', checked: false, isDisk: true, header: '网络接口监测器', title: '网卡', suffix: 'status'},
    ],
    Netscreen: [
      {type: 'Ping', checked: true, isDisk: false, header: 'Ping监测器', content: 'ping', title: 'Ping'},
      {type: 'SnmpUpTime', checked: true, isDisk: false, header: '设备运行时间监测器', content: '设备运行时间', title: '设备运行时间'},
      {type: 'NetWork', checked: false, isDisk: true, header: '网络接口监测器', title: '网卡', suffix: 'status'},
    ],
    PIX: [
      {type: 'Ping', checked: true, isDisk: false, header: 'Ping监测器', content: 'ping', title: 'Ping'},
      {type: 'SnmpUpTime', checked: true, isDisk: false, header: '设备运行时间监测器', content: '设备运行时间', title: '设备运行时间'},
      {type: 'NetWork', checked: false, isDisk: true, header: '网络接口监测器', title: '网卡', suffix: 'status'},
    ],
    WirelessNetwork: [
      {type: 'Ping', checked: true, isDisk: false, header: 'Ping监测器', content: 'ping', title: 'Ping'},
      {type: 'SnmpUpTime', checked: true, isDisk: false, header: '设备运行时间监测器', content: '设备运行时间', title: '设备运行时间'},
      {type: 'NetWork', checked: false, isDisk: true, header: '网络接口监测器', title: '网卡', suffix: 'status'},
    ],
    DME3000: [{type: 'SnmpUpTime', checked: false, isDisk: false, header: '设备运行时间监测器', content: '设备运行时间', title: '设备运行时间'}],
    LiebertCorp: [
      {type: 'Ping', checked: false, isDisk: false, header: 'Ping监测器', content: 'ping', title: 'Ping'},
      {type: 'SnmpUpTime', checked: false, isDisk: false, header: '设备运行时间监测器', content: '设备运行时间', title: '设备运行时间'},
    ],
    Raritan: [
      {type: 'Ping', checked: false, isDisk: false, header: 'Ping监测器', content: 'ping', title: 'Ping'},
      {type: 'SnmpUpTime', checked: false, isDisk: false, header: '设备运行时间监测器', content: '设备运行时间', title: '设备运行时间'},
    ],
    Santakups:[{type: 'Ping', checked: false, isDisk: false, header: 'Ping监测器', content: 'ping', title: 'Ping'}],
    Weblogic: [{type: 'Ping', checked: false, isDisk: false, header: 'Ping监测器', content: 'ping', title: 'Ping'}],
    Network: [
      {type: 'Ping', checked: true, isDisk: false, header: 'Ping监测器', content: 'ping', title: 'Ping'},
      {type: 'SnmpUpTime', checked: true, isDisk: false, header: '设备运行时间监测器', content: '设备运行时间', title: '设备运行时间'},
      {type: 'NetWork', checked: false, isDisk: true, header: '网络接口监测器', title: '网卡', suffix: 'status'},
    ],
    EMCStorage: [{type: 'StorageFaults', checked: false, isDisk: false, header: '存储设备故障状态', content: '存储故障', title: '存储故障'}],
    IBMStorage: [
      {type: 'Ping', checked: false, isDisk: false, header: 'Ping监测器', content: 'ping', title: 'Ping'},
      {type: 'StorageStatus', checked: false, isDisk: false, header: '存储设备状态', content: '存储状态', title: '存储状态'},
    ]
  }
};

export default ResourceUtils;
